// ForgotPasswordPage — 비밀번호 재설정 메일 요청.
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../api/client';
import useIsMobile from '../hooks/useIsMobile';
import { COLORS } from '../utils/uiStyles';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const mobile = useIsMobile();
  const S = styles(mobile);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);
    try {
      const res = await authAPI.forgotPassword({ email });
      setMessage(res.data.message);
    } catch {
      setError('요청 처리 중 오류가 발생했습니다.');
    } finally { setLoading(false); }
  };

  return (
    <div style={S.wrap}>
      <div style={S.card}>
        <h2 style={S.title}>비밀번호 찾기</h2>
        <p style={S.desc}>가입 시 사용한 이메일을 입력하시면 재설정 링크를 보내드립니다.</p>
        {message ? (
          <p style={S.ok} role="status">{message}</p>
        ) : (
          <form onSubmit={handleSubmit} style={S.form}>
            <label style={S.label}>이메일</label>
            <input style={S.input} type="email" placeholder="name@ourbox.co.kr" autoComplete="email" spellCheck={false}
              value={email} onChange={(e) => setEmail(e.target.value)} required />
            {error && <p style={S.err} role="alert">{error}</p>}
            <button style={{ ...S.btn, ...(loading ? S.btnDisabled : {}) }} type="submit" disabled={loading}>
              {loading ? '전송 중...' : '재설정 링크 전송'}
            </button>
          </form>
        )}
        <p style={S.link}><Link to="/login">로그인으로 돌아가기</Link></p>
      </div>
    </div>
  );
}

const styles = (mobile) => ({
  wrap: { display:'flex', justifyContent:'center', alignItems:'center', minHeight:'var(--gw-app-h, 100dvh)', background:'#f5f5f5', boxSizing:'border-box', padding: mobile ? '16px' : 0 },
  card: { background:'white', padding: mobile ? '28px 20px' : '40px', borderRadius:'12px', boxShadow: mobile ? 'none' : '0 2px 12px rgba(0,0,0,.1)', width: mobile ? '100%' : '360px', maxWidth: mobile ? '420px' : undefined, boxSizing:'border-box' },
  title: { textAlign:'center', marginBottom:'10px', fontSize:'20px', fontWeight:'700' },
  desc: { fontSize:'13px', color:'#666', margin:'0 0 18px', lineHeight:'1.6', textAlign:'center' },
  form: { display:'flex', flexDirection:'column' },
  label: { fontSize:'12px', color:'#4b5563', fontWeight:700, marginBottom:'6px' },
  input: { width:'100%', padding: mobile ? '13px 14px' : '10px 12px', marginBottom:'12px', border:'1px solid #d1d5db', borderRadius:'6px', fontSize: mobile ? '16px' : '14px', boxSizing:'border-box', minHeight: mobile ? '46px' : '40px', outline:'none' },
  btn: { width:'100%', padding: mobile ? '14px' : '12px', minHeight: mobile ? '48px' : '42px', background:COLORS.primary, color:'white', border:'none', borderRadius:'6px', fontSize:'15px', fontWeight:700, cursor:'pointer' },
  btnDisabled: { background:COLORS.border, color:COLORS.textMuted, cursor:'not-allowed' },
  err: { color:'#b91c1c', background:'#fef2f2', border:'1px solid #fecaca', borderRadius:'8px', padding:'10px 12px', fontSize:'13px', margin:'0 0 12px', lineHeight:1.5 },
  ok: { color:'#166534', background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:'10px', padding:'12px', fontSize:'14px', margin:'0 0 16px', textAlign:'center', lineHeight:1.6 },
  link: { textAlign:'center', marginTop:'16px', fontSize:'13px' },
});
